export const siteSettings = {
  name: "Anchor Wise",
  link: "https://anchorwise.org",
  email: "support@anchorwise.org",
  appLink: "https://app.anchorwise.org",
};
